__webpack_require__.p = "/monsters/";